import styled from '@emotion/styled';

export const PREVIEW_SEMI_CIRCLE_WIDTH = 900;
export const PREVIEW_SEMI_CIRCLE_SCALE = 0.6;

export const SemiCircleScaleWrapper = styled.div({
  width: '100%',
  height: `${PREVIEW_SEMI_CIRCLE_WIDTH * PREVIEW_SEMI_CIRCLE_SCALE * 0.5}px`,
  overflow: 'hidden',
  position: 'relative',
});

export const SemiCircleScaleContent = styled.div({
  width: `${PREVIEW_SEMI_CIRCLE_WIDTH}px`,
  transformOrigin: 'top left',
  transform: `scale(${PREVIEW_SEMI_CIRCLE_SCALE})`,
  position: 'absolute',
  top: 0,
  left: 0,
});
